import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { ReportType } from '@/api/routes/reports/types';
import { fetchReportTypes } from '@/store/slices/reports/filters/types/actionCreators';

interface InitialState {
  reportTypes: ReportType[],
  reportTypeIds: string[],
  isLoading: boolean,
  error: string,
}

const initialState: InitialState = {
  reportTypes: [],
  reportTypeIds: [],
  isLoading: false,
  error: '',
};

export const typesSlice = createSlice({
  name: 'reportTypes',
  initialState,
  reducers: {},
  extraReducers: {
    [fetchReportTypes.fulfilled.type]: (state, action: PayloadAction<ReportType[]>) => {
      state.isLoading = false;
      state.error = '';
      state.reportTypes = action.payload;
      state.reportTypeIds = action.payload.map(({ id }) => id);
    },
    [fetchReportTypes.pending.type]: (state) => {
      state.isLoading = true;
    },
    [fetchReportTypes.rejected.type]: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export default typesSlice.reducer;
